import React from "react";
import { useShop } from "providers/ShopProvider";
import { Banner, Heading, TextContainer } from "@shopify/polaris";
import { useHistory } from "react-router-dom";

export default function DKIMVerificationAlert() {
  const { shop } = useShop();
  const history = useHistory();

  const handleCompleteSetup = () => {
    // Navigate to settings with query parameters for deep linking
    history.push("/settings?tab=notifications&scroll=email-sender-signature");
  };

  // Show banner when shop has confirmed sender signature but DKIM is not verified
  const shouldShowBanner = Boolean(
    shop?.emailSenderSignature?.Confirmed && 
    !shop?.emailSenderSignature?.DKIMVerified
  );

  if (!shouldShowBanner) {
    return null;
  }

  return (
    <Banner
      status="warning"
      action={{ content: "Complete Setup", onAction: handleCompleteSetup }}
    >
      <Heading>Complete DKIM verification for better email deliverability</Heading>
      <TextContainer>
        <p>
          Your email address is confirmed, but DKIM verification is still needed 
          to ensure your ID verification notifications reach customers reliably.
        </p>
        <p>
          Complete the DNS setup in your email settings to improve email 
          deliverability and build customer trust.
        </p>
      </TextContainer>
    </Banner>
  );
}